import { connect } from 'react-redux'
import Sidebar from '../../../../common/containers/Sidebar'
import Card from '../../../../common/containers/Card'
import { Route, Routes } from 'react-router'
import { useState } from 'react'
import RegionList from './RegionList'
import RegionEdit from './RegionEdit'

let RegionPage = () => {
    const [pageAttr, setPageAttr] = useState({})
    return (
        <Sidebar>
            <Card {...pageAttr}>
                <Routes>
                    <Route path='/edit/:id' element={<RegionEdit setPageAttr={setPageAttr} />} />
                    <Route path='/add' element={<RegionEdit setPageAttr={setPageAttr} />} />
                    <Route path='/' element={<RegionList setPageAttr={setPageAttr} />} />
                </Routes>
            </Card>
        </Sidebar>
    )
}

export default connect()(RegionPage)